import React from "react";

const FootNoteData = (props) => {
    let html = props.footNoteData.replaceAll("(br)", "<br />");

    return <div className="c-footnote-data" dangerouslySetInnerHTML={{ __html: html }}></div>;
};

export default FootNoteData;
